import { Link } from 'react-router-dom';
import { CATEGORIES } from '@/types/movie';
import { movies } from '@/mocks/movies';

export default function CategoryShortcuts() {
  return (
    <section className="mx-auto w-full px-4 py-14 md:px-8 md:py-20">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="font-display text-sm tracking-[0.25em] text-primary-400">BROWSE</p>
          <h2 className="mt-1 text-2xl text-foreground-950 md:text-3xl">按类型找片</h2>
        </div>
        <Link
          to="/search"
          className="flex items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition hover:text-primary-400"
        >
          浏览全部影片 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
        {CATEGORIES.map((cat) => {
          const count = movies.filter((m) => m.category === cat.key).length;
          return (
            <Link
              key={cat.key}
              to={`/category/${encodeURIComponent(cat.key)}`}
              className="group relative overflow-hidden rounded-lg border border-background-300/50 bg-background-100 p-6 transition hover:border-primary-400/60"
            >
              <div className="flex items-start justify-between">
                <span className="flex h-14 w-14 items-center justify-center rounded-lg bg-primary-500/15 text-primary-400">
                  <i className={`${cat.icon} text-2xl`}></i>
                </span>
                <span className="font-display text-4xl text-background-300 transition group-hover:text-primary-500/40">
                  {cat.en.toUpperCase().slice(0, 3)}
                </span>
              </div>
              <h3 className="mt-6 text-lg text-foreground-950">{cat.label}类午夜影片</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{cat.description}</p>
              <p className="mt-5 flex items-center gap-2 text-xs text-foreground-500">
                <span className="rounded-full bg-secondary-100/80 px-2.5 py-1 text-secondary-900">
                  {count} 部影片
                </span>
                <span className="flex items-center gap-1 transition group-hover:text-primary-400">
                  查看片单 <i className="ri-arrow-right-line"></i>
                </span>
              </p>
            </Link>
          );
        })}
      </div>
    </section>
  );
}